import {Component, OnInit} from '@angular/core';
import {UserService} from '../../services/user/user.service';
import {WorkGroupsService} from '../../services/work-groups/work-groups.service';
import {UntypedFormBuilder, UntypedFormGroup, FormArray, Validators, ReactiveFormsModule} from '@angular/forms';
import {AlertService} from '../../services/alert/alert.service';
import {LoadingService} from '../../services/loading/loading.service';
import {PaginationComponent} from "../../shared/pagination/pagination.component";
import {ModalModule} from "ngx-bootstrap/modal";


@Component({
    selector: 'app-work-group-permissions',
    templateUrl: './work-group-permissions.component.html',
    styleUrls: ['./work-group-permissions.component.css'],
    imports: [
    PaginationComponent,
    ReactiveFormsModule,
    ModalModule
]
})
export class WorkGroupPermissionsComponent implements OnInit {
  agencyCode = '047';
  bureauCode = '09';
  workGroup = '1';

  /**
   * @member scopes: Enum options for work_group_admin_scope
   * @member rights: Enum options for book_shipment and bill_lading
   */
  scopes: any = ['Agency Wide', 'Bureau Wide', 'Work Group Wide', 'None'];
  rights: any = ['Agency Wide View', 'Agency Wide Update', 'Bureau Wide View', 'Bureau Wide Update', 'Work Group Wide View', 'Work Group Wide Update', 'None'];

  /**
   * @member users: list of users in work group
   * @member selectedUser: the user that is selected while update pop-up is active
   */
  users: any;
  selectedUser: any;

  // Pagination
  // Pagination Variables
  itemsPerPage = 10;
  totalItems = 0;
  currentPage = 1;
  pageReset = false;
  previousPage = 0;
  userPage: any = null;
  pageMap: Map<number, any> = new Map<number, any>();
  showingStart: number;
  showingEnd: number;

  /**
   * @member permissionsForm: form group representing the TransactionAccessRights row being updated
   */
  permissionsForm: UntypedFormGroup;

  constructor(private userService: UserService, private workGroupsService: WorkGroupsService, private fb: UntypedFormBuilder,
              private alertService: AlertService, private loadingService: LoadingService) {
  }

  ngOnInit() {
    // initialize form group
    this.permissionsForm = this.fb.group({
      tranAccId: [null],
      userId: [null],
      workGroupAdminScope: [null],
      bookShipment: [null],
      billOfLading: [null],
      updateProgram: [null],
      updateId: [null],
      updateDate: [null]
    });

    // get list of user
    this.getUsers();

   /* this.permissionsForm.get('workGroupAdminScope').valueChanges.subscribe(value => {
      console.log('workGroupAdminScope changed', value);
    });

    this.permissionsForm.get('bookShipment').valueChanges.subscribe(value => {
      console.log('bookShipment changed', value);
    });

    this.permissionsForm.get('billOfLading').valueChanges.subscribe(value => {
      console.log('billOfLading changed', value);
    });*/

  }

  /**
   * @function
   * @description get a list of users in the work group
   */
  getUsers() {
    this.loadingService.show();
    this.workGroupsService.getUsersByWorkGroup(this.agencyCode, this.bureauCode, this.workGroup).subscribe(users => {
      console.log('Users: ', users);
      this.users = users;
      this.alertService.success('Successfully Retrieved ' + this.users.length + ' Users!');
    }, (error) => {
      this.loadingService.hide();
      this.alertService.error('Error Getting Users!');
    }, () => {
      this.setupPagination();
      this.loadingService.hide();
    });
  }

  /**
   * @function
   * @param user: the user that was selected from the list on screen
   * @description update the form group with values from the selected user
   */
  userSelected(user) {
    this.selectedUser = user;
    this.permissionsForm.setValue({
      tranAccId: user.transactionAccessRights.tranAccId,
      userId: user.transactionAccessRights.userId,
      workGroupAdminScope: user.transactionAccessRights.workGroupAdminScope,
      bookShipment: user.transactionAccessRights.bookShipment,
      billOfLading: user.transactionAccessRights.billOfLading,
      updateProgram: user.transactionAccessRights.updateProgram,
      updateId: user.transactionAccessRights.updateId,
      updateDate: user.transactionAccessRights.updateDate
    });
    console.log(this.permissionsForm.value);
  }

  /**
   * @function
   * @description update the user when the save button on screen is pressed. TransactionAccessRights will be updated
   */
  save() {
    this.loadingService.show();
    this.workGroupsService.updateTransactionAccessRights(this.permissionsForm.value).subscribe(value => {
      console.log(value);
      if (value) {
        this.alertService.success('Successfully Updated User!');
      }
    }, (error) => {
      this.alertService.error('Error Updating User!');
      console.log('There was an error updating');
    }, () => {
      this.loadingService.hide();
      this.getUsers();
    });
  }

  isWorkGroupAdmin(user): boolean {
    let isWorkGroupAdmin = false;
    for (const role of user.roles) {
      if (role.id == 7 || role.id == 2) {
        isWorkGroupAdmin = true;
        break;
      }
    }
    return isWorkGroupAdmin;
  }

  setupPagination() {
    this.pageMap = new Map<number, any>();
    this.totalItems = this.users.length;
    let pageCount = 1;
    for (let i = 0; i < this.totalItems; i = i + this.itemsPerPage) {
      const pageOfCustomers = this.users.slice(i, i + this.itemsPerPage);
      this.pageMap.set(pageCount, pageOfCustomers);
      pageCount++;
    }
    // Reset the current page to the first page
    this.currentPage = 1;
    this.userPage = this.pageMap.get(this.currentPage);
    this.showingStart = 1;

    const end = this.currentPage * this.itemsPerPage;
    if (end > this.totalItems) {
      this.showingEnd = this.totalItems;
    } else {
      this.showingEnd = end;
    }
  }

  // page event emitted from pagination component. Set the Current page as long as there is data to be displayed
  page(currentPage) {
    this.currentPage = currentPage;
    if (this.userPage != null && this.userPage.length !== 0) {
      this.userPage = this.pageMap.get(currentPage);
    }

    const end = this.currentPage * this.itemsPerPage;
    if (end > this.totalItems) {
      this.showingEnd = this.totalItems;
    } else {
      this.showingEnd = end;
    }
    this.showingStart = (this.currentPage * this.itemsPerPage) - this.itemsPerPage + 1;
  }

  // set the value of items per page when change from pagination component
  // this value is used for mapping in setupPagination() function
  itemsPerPageChanged(itemsPerPage) {
    console.log('Resetting Up Pagination!' + itemsPerPage);
    this.itemsPerPage = itemsPerPage;
    if (this.userPage != null && this.userPage.length !== 0) {
      this.setupPagination();
      this.pageReset = true;
    }
  }
}
